import React, { createContext, useContext } from 'react';

interface DemoModeContextValue {
  isDemoMode: boolean;
}

const DemoModeContext = createContext<DemoModeContextValue>({ isDemoMode: false });

export const DemoModeProvider: React.FC<{ isDemoMode: boolean; children: React.ReactNode }> = ({ isDemoMode, children }) => (
  <DemoModeContext.Provider value={{ isDemoMode }}>
    {children}
  </DemoModeContext.Provider>
);

export const useDemoMode = () => useContext(DemoModeContext);
